<template>
  <div ref="chartDom" class="line-chart-container"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'LineChart',
  props: {
    // 基础配置
    xAxisData: {
      type: Array,
      default: () => ['2019-01', '2019-02', '2019-03', '2019-04', '2019-05', '2019-06']
    },
    seriesData: {
      type: Array,
      default: () => [23, 60, 20, 36, 23, 85]
    },
    seriesName: {
      type: String,
      default: '用户数'
    },
    // 颜色配置
    lineColor: {
      type: String,
      default: '#0068FF',
      validator: (value) => /^#([0-9A-F]{3}){1,2}$/i.test(value)
    },
    // 其他可配置项
    smooth: {
      type: Boolean,
      default: true
    },
    tooltipBackground: {
      type: String,
      default: '#fff'
    }
  },
  data() {
    return {
      chartInstance: null
    };
  },
  watch: {
    // 深度监听所有props变化
    $props: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },
  beforeDestroy() {
    if (this.chartInstance) {
      window.removeEventListener('resize', this.resizeChart);
      this.chartInstance.dispose();
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chartDom) return;

      this.chartInstance = echarts.init(this.$refs.chartDom);
      this.updateChart();
    },
    updateChart() {
      if (!this.chartInstance) return;

      const option = {
        grid: {
          left: '0%',
          right: '6%',
          top: '10%',
          bottom: '20%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          borderWidth: 0,
          backgroundColor: this.tooltipBackground,
          textStyle: {
            color: "#565656",
          },
          confine: true,
          extraCssText: "box-shadow: 0px 2px 8px 0px #cacaca;border-radius: 4px;opacity: 0.9;",
          axisPointer: {
            lineStyle: {
              color: '#0D89FF'
            }
          }
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLine: {
            show: true, // 确保显示轴线（默认就是true）
            lineStyle: {
              color: '#EFEFEF', // 轴线颜色
              width: 1,      // 轴线宽度
              type: 'solid'  // 确保是实线（默认值）
            }
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 11,
            },
            rotate: "-45",
          },
        },
        yAxis: {
          type: 'value',
          splitNumber: 4,
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#F0F0F0'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#333'
            }
          },
          nameTextStyle: {
            color: '#999'
          },
          splitArea: {
            show: false
          }
        },
        dataZoom: [
          {
            show: true,
            height: 20,
            bottom: 30,
            backgroundColor:'transparent',
            start: 0,
            end: 100,
            showDetail:false,
            dataBackground:{
              lineStyle:{
                color:'#0068FF'
              },
              areaStyle:{
                color:'#E7F4FF'
              }
            },
            selectedDataBackground:{
              lineStyle:{
                color:'#0087FD',
                width:1,
              },
              areaStyle:{
                color:'#0087FD'
              }
            },
            fillerColor:'rgba(236,238,245,0.5)',
            borderColor:'rgba(236,238,245,1)',
            borderRadius:4,
            // handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleIcon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "80%",
            handleStyle: {
              color: {
                type: 'radial',
                x: 0.9,
                y: 0.9,
                r: 0.9,
                colorStops: [{
                  offset: 0, color: '#00FEB2' // 0% 处的颜色
                }, {
                  offset: 1, color: '#0087FD' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              },
              borderWidth: 0,
            },
            moveHandleStyle:{
              color: "#afc7e3",
              borderColor: "#afc7e3",
            },
            brushStyle:{
              color:'red',
            },
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
          // {
          //   type: 'slider',  // 滑动条缩放
          //   show: true,
          //   xAxisIndex: [0],  // 只对 X 轴进行缩放
          //   start: 0, // 初始显示的起始位置
          //   end: 100,  // 初始显示的结束位置（百分比）
          // },
          // {
          //   type: 'inside',  // 鼠标滚轮缩放
          //   xAxisIndex: [0],
          //   start: 0,
          //   end: 100,
          // },
        ],
        series: [{
          name: this.seriesName,
          type: 'line',
          data: this.seriesData,
          lineStyle: {
            width: 2,
            color: this.lineColor,
            // shadowColor: '#CADCF1',
            // shadowBlur: 1,
            // shadowOffsetY: 10
          },
          itemStyle: {
            opacity: 0
          },
          emphasis: {
            itemStyle: {
              opacity: 1,
              borderColor: this.lineColor,
            }
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: "rgba(58,132,255,0)",
              },
              {
                offset: 1,
                color: "rgba(58,132,255,1)",
              },
            ])
          } ,
          smooth: this.smooth
        },
        ]
      };

      this.chartInstance.setOption(option);
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  }
};
</script>

<style scoped>
.line-chart-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/LineChart.vue